import { render, staticRenderFns } from "./TaskDetails.vue?vue&type=template&id=49c1b586&scoped=true"
import script from "./TaskDetails.vue?vue&type=script&lang=js"
export * from "./TaskDetails.vue?vue&type=script&lang=js"
import style0 from "./TaskDetails.vue?vue&type=style&index=0&id=49c1b586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c1b586",
  null
  
)

export default component.exports